import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import CaseCard from "@/components/feature/CaseCard";
import { getFeaturedCases } from "@/utils/cases";

export default function FeaturedSection() {
  const featured = getFeaturedCases();
  const [lead, ...rest] = featured;

  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-[1240px] mx-auto px-4 md:px-10">
        <SectionHeading
          eyebrow="本周重点档案"
          title="先从这三篇开始看"
          desc="它们覆盖了最常见的三类场景：签合同的、买大件的、以及被人情推着做决定的。"
          action={
            <Link
              to="/cases"
              className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap"
            >
              查看全部档案
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          }
        />

        {lead && (
          <div className="mb-6">
            <CaseCard item={lead} variant="wide" />
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {rest.map((item) => (
            <CaseCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}